<div class="tabela-scroll">
  <app-table *ngIf="items.length > 0" [colunas]="colunas" [items]="items"></app-table>
  <div class="sem-dados" *ngIf="items.length === 0 && !isLoading">
    {{ emptyMessage }}
  </div>
</div>
<mat-paginator *ngIf="hasDataAll"
  class="dashboard-paginator"
  [length]="paginatorLength"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  [pageIndex]="pageIndex"
  (page)="onPaginate($event)">
</mat-paginator>
